// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__8mTu8","box":"WorkspacesBox_box__qczrS","node":"WorkspacesBox_node__2uSr-"};